<div class="js-container-mobile-category-menu container-mobile-category-menu">
  <ul class="first-level">
    <li *ngFor="let category of menu; let i = index" class="js-container">
      <div class="line justify-content-between">
        <button
          type="button"
          (click)="open(category)"
          #btnFirstLevel
        >
          <span class="label">{{ category.linkName }}</span>
          <span *ngIf="category.children?.length" class="ms-auto icon material-symbols-outlined">keyboard_arrow_right</span>
        </button>
      </div>

      <div *ngIf="category.children?.length" class="js-level second-level">
        <div class="header">
          <div class="line">
            <button
              type="button"
              (click)="close()"
              #btnClose
            >
              <span *ngIf="category.children?.length" class="icon material-symbols-outlined">keyboard_arrow_left</span>
              <span class="label">{{ category.linkName }}</span>
            </button>
          </div>
        </div>

        <ul>
          <li *ngFor="let subCategory of category.children; let i = index" class="js-container third-level-container">
            <div class="line justify-content-between">
              <button
                type="button"
                (click)="toggleChildren(subCategory)"
                #btnToggleChildren
              >
                <span class="label">{{ subCategory.linkName }}</span>
                <span *ngIf="subCategory.children?.length" class="ms-auto js-icon icon material-symbols-outlined">keyboard_arrow_right</span>
              </button>
            </div>

            <ul *ngIf="subCategory.children?.length" class="js-level third-level">
              <li *ngFor="let link of subCategory.children">
                <div class="line">
                  <button
                    type="button"
                    class="w-100"
                    (click)="open(link)"
                  >
                    <span class="label">{{ link.linkName }}</span>
                  </button>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
